import agendaScreenshot from "../../../../content/blog/assets/agenda_screenshot_retina-1.png";
import schedulerExample from "../../../../content/blog/assets/scheduler_example.png";
import * as React from 'react';
export default {
  agendaScreenshot,
  schedulerExample,
  React
};